import { createMuiTheme } from '@material-ui/core/styles'

/**
 * Material UI Theme - override theme font and size
 * Note: Overrides for components should be done through scss and not globally here
 * @type {Theme}
 */
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#0F5CA3',
      contrastText: '#FFFFFF'
    },
    secondary: {
      main: '#F1AF0F',
      contrastText: '#2A3035',
      dark: '#D89D0D'
    }
  }
})

export default theme
